var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "9.5",
            stroke: "#B3B3B3",
          },
        }),
        _c("path", {
          attrs: {
            d: "M13 14H7V13.6098C7 12.5617 7.85972 11.5749 9.10421 10.7554L10.1743 10.053C10.7395 9.67943 11.5932 9.1331 11.5932 8.24669C11.5932 7.5331 11.0461 7.04251 10.1323 7.04251C9.06212 7.04251 8.37074 7.72822 8.37074 8.84878L7.1503 8.75401C7.16834 7.17631 8.27455 6 10.2224 6C11.9659 6 12.8257 6.94216 12.8257 8.21324C12.8257 9.57353 11.8397 10.2369 10.8417 10.8892L9.68136 11.6474C9.14629 11.9986 8.62926 12.4669 8.43086 12.9463H13V14Z",
            fill: "#666666",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }